import { Competence } from './competence';

export class Profil {
    id: string;
    title: string;
    competences: Competence[];
}
